import axios from "axios";
import { message } from "antd";

const baseURL = process.env.REACT_APP_BASE_URL;

const drEasyApi = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token from localStorage or sessionStorage to each request
drEasyApi.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("docTkn") || sessionStorage.getItem("docTkn");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle network errors and HTTP status errors
drEasyApi.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, request, code } = error;

    // Handle network errors
    if (!response) {
      // Network error (no response received)
      // if (code === 'ECONNABORTED') {
      //   message.error("Request timeout. Please check your connection and try again.");
      // } else if (code === 'ERR_NETWORK') {
      //   message.error("Network error. Please check your internet connection.");
      // } else if (request) {
      //   // Request was made but no response received
      //   message.error("Unable to connect to server. Please try again later.");
      // } else {
      //   // Something else happened
      //   message.error("An unexpected error occurred. Please try again.");
      // }
      return Promise.reject(error);
    }

    // Handle HTTP status errors
    const status = response.status;
    
    if (status === 401 ) {
      message.error("Session expired. Please log in again.");
      setTimeout(() => {
        window.location.href = "/auth"; // Adjust auth path as needed
      }, 1000);
    } 
    return Promise.reject(error);
  }
);

export default drEasyApi;